import {Component, Input, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {AppState, selectActivePublicationState} from '@store/app.states';
import {OnDestroyMixin, untilComponentDestroyed} from '@w11k/ngx-componentdestroyed';
import * as activePublication from '@app/components/publications/create-publication/_store/active-publication.reducers';
import {Observable} from 'rxjs';

import {AbstractControl, UntypedFormArray, FormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators} from '@angular/forms';
import {SavePublication, UtmAdd, UtmClear, UtmListUpdate, UtmRemove} from '@app/components/publications/create-publication/_store/active-publication.actions';
import {distinctUntilChanged} from 'rxjs/operators';

@Component({
    selector: 'app-utm-editor',
    templateUrl: './utm-editor.component.html',
    styleUrls: ['./utm-editor.component.scss'],
    standalone: false
})
export class UtmEditorComponent extends OnDestroyMixin implements OnInit {

  public getActivePublication$: Observable<activePublication.State> = this.store
    .pipe(
      select(selectActivePublicationState),
      distinctUntilChanged(),
      untilComponentDestroyed(this),
    );

  utmFormArray: UntypedFormArray = new UntypedFormArray([]);
  publicationDatas = null;

  constructor(
    private store: Store<AppState>,
  ) {
    super();
  }

  ngOnInit(): void {

    this.getActivePublication$.pipe(untilComponentDestroyed(this)).subscribe((publication) => {

      if (publication.datas) {

        this.publicationDatas = publication.datas;

        if (publication.datas.linkInfos?.utm) {

          if (publication.datas.linkInfos.utm.length !== this.utmFormArray.controls.length) {

            this.utmFormArray.clear();

            publication.datas.linkInfos.utm.forEach((aUtm) => {
              const group = new UntypedFormGroup({

                key: new UntypedFormControl(aUtm.key, [Validators.required, this.noWhiteSpaceValidator()]),
                value: new UntypedFormControl(aUtm.value, [Validators.required]),

              });
              this.utmFormArray.push(group);
            });

          } else {

            this.utmFormArray.patchValue(publication.datas.linkInfos.utm, {emitEvent: false});

          }

        }

        this.utmFormArray.markAsPristine();

      }

    });

    this.utmFormArray.valueChanges.subscribe(() => {
      if (this.utmFormArray.dirty) {
        // On va patcher direct les values avec des _
        //
        this.store.dispatch(new UtmListUpdate({list: this.utmFormArray.getRawValue()}));
        //
        //
      }
    });

  }

  addUtm(): void {
    this.store.dispatch(new UtmAdd());
  }

  removeUtm(i): void {
    this.store.dispatch(new UtmRemove({index: i}));
  }

  clearUtm(): void {
    this.store.dispatch(new UtmClear());
  }

  saveWithUtms(): void {
    this.store.dispatch(new SavePublication({publication: this.publicationDatas}));
  }

  addStandardUtm(): void {

    const standardUtms: { key: string, value: string }[] = [
      {
        key: 'utm_source', value: '',
      },
      {
        key: 'utm_medium', value: '',
      },
      {
        key: 'utm_campaign', value: '',
      },
      {
        key: 'utm_term', value: '',
      },
      {
        key: 'utm_content', value: '',
      },
    ];

    this.store.dispatch(new UtmListUpdate({list: [...this.utmFormArray.getRawValue(), ...standardUtms]}));
  }

  //
  // Custom validators
  //
  noWhiteSpaceValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      if (control.value) {
        const forbidden = control.value.indexOf(' ') >= 0;
        return forbidden ? {hasWhitespace: {value: control.value}} : null;
      }
      return null;
    };
  }


}
